import { Text } from "@/elements"
import { Checkbox } from "@/elements/Checkbox"

interface Props {
  name: string
  selected: boolean
  onClick: () => void
  count?: number
}

export const FilterItem: React.FC<Props> = ({ name, selected, onClick, count }) => {
  return (
    <div className="flex w-full cursor-pointer items-center rounded-md p-2 hover:bg-bg-2" onClick={onClick}>
      <Checkbox checked={selected} onChange={e => null} />
      <Text className="ml-2" maxLines={1}>
        {name}
      </Text>
      {count !== undefined ? <Text className="ml-2">{count}</Text> : <div />}
    </div>
  )
}
